"use client";

import Link from "next/link";

// @hooks
import { usePathname } from "next/navigation";

// @utils
import { cn } from "@/utils";

const NAV_ITEMS = [
  { href: "/explore/roi", label: "ROI" },
  { href: "/liquidity", label: "Liquidity" },
  { href: "/explore/shares", label: "Shares" },
  { href: "/explore/adoption", label: "Adoption" },
  { href: "/explore/inflation", label: "Inflation" },
];

export function ExploreNav() {
  const pathname = usePathname();

  return (
    <nav
      className="mb-8 flex flex-wrap gap-2"
      aria-label="Analytics sections"
    >
      {NAV_ITEMS.map(({ href, label }) => {
        const isActive =
          pathname === href || pathname.startsWith(`${href}/`);

        return (
          <Link
            key={href}
            href={href}
            className={cn(
              "relative rounded-full px-5 py-2.5 text-sm font-medium transition-all duration-300 ease-premium",
              isActive
                ? "bg-white text-primary shadow-[0_8px_24px_-6px_rgba(255,255,255,0.25)]"
                : "border border-white/[0.06] bg-white/[0.02] text-foreground backdrop-blur-sm hover:border-hex-400/30 hover:bg-white/[0.05] hover:text-white",
            )}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
}

export default ExploreNav;
